export default __webpack_public_path__ + "static/media/bannerOnex2.909acc5b.png";